export default "__VITE_ASSET__eDiOP1ai__"